import { render, staticRenderFns } from "./ModalFileCapacitador.vue?vue&type=template&id=5968fa99&scoped=true"
import script from "./ModalFileCapacitador.vue?vue&type=script&lang=js"
export * from "./ModalFileCapacitador.vue?vue&type=script&lang=js"
import style0 from "./ModalFileCapacitador.vue?vue&type=style&index=0&id=5968fa99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5968fa99",
  null
  
)

export default component.exports